import type {
  TicketingMetadataResponse,
  TicketProject,
  TicketType
} from "@/api/useJira.types"

export const getProjectTypes = (
  response: TicketingMetadataResponse | undefined,
  projectId: string | undefined
): TicketType[] =>
  response?.data?.projects.find(({ id }) => id === projectId)?.types || []

export const toRepositoryProjects = (
  repository: string | undefined
): TicketProject[] => (repository ? [{ id: repository, name: repository }] : [])

export const getTypeFields = (types: TicketType[], typeId?: string) =>
  types.find(({ id }) => id === typeId)?.fields || []

// Keeps a preferred id while it is still offered, else falls back to the first option
export const pickOptionId = (
  options: (TicketProject | TicketType)[],
  preferredId?: string
) =>
  preferredId && options.some(({ id }) => id === preferredId)
    ? preferredId
    : options[0]?.id
